export default function YesOrNotBubble({
  actionYes,
  actionNo,
}: {
  actionYes: () => void;
  actionNo: () => void;
}) {
  return (
    <div className="vcw-additionnal-message-container">
      <button className="vcw-yes-btn" onClick={actionYes}>
        Oui
      </button>
      <button className="vcw-not-btn" onClick={actionNo}>
        Non
      </button>
    </div>
  );
}
